var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        width: "25",
        height: "25",
        viewBox: "0 0 18 18",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }
    },
    [
      _c("path", {
        attrs: {
          d:
            "M3.60005 2.39999C3.46635 2.40019 3.33656 2.44504 3.23125 2.52741C3.12595 2.60978 3.05118 2.72497 3.0188 2.85468L3.01763 2.85585C3.0155 2.86401 3.01355 2.87222 3.01177 2.88046L1.8188 7.65234C1.80644 7.70059 1.80015 7.75019 1.80005 7.79999C1.80005 7.95912 1.86326 8.11174 1.97578 8.22426C2.08831 8.33678 2.24092 8.39999 2.40005 8.39999V14.4C2.40005 15.0558 2.94421 15.6 3.60005 15.6H14.4C15.0559 15.6 15.6 15.0558 15.6 14.4V8.39999C15.7592 8.39999 15.9118 8.33678 16.0243 8.22426C16.1368 8.11174 16.2 7.95912 16.2 7.79999C16.2 7.75019 16.1937 7.70059 16.1813 7.65234L14.9825 2.85585L14.9813 2.85468C14.9489 2.72497 14.8741 2.60978 14.7688 2.52741C14.6635 2.44504 14.5337 2.40019 14.4 2.39999H9.00005H3.60005ZM9.00005 4.79999L12.6 8.39999H14.4V14.4H10.2V11.4C10.2 10.737 9.66305 10.2 9.00005 10.2C8.33705 10.2 7.80005 10.737 7.80005 11.4V14.4H3.60005V8.39999H5.40005L9.00005 4.79999ZM4.80005 10.2V12H6.60005V10.2H4.80005ZM11.4 10.2V12H13.2V10.2H11.4Z",
          fill: "currentColor"
        }
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }